import { Box, Typography, Chip, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, IconButton, Tooltip, TablePagination, TextField } from '@mui/material';
import { Edit, Delete, Visibility, CheckCircle } from '@mui/icons-material';
import { Video } from '../../types';

interface VideosTableProps {
  videos: Video[];
  loading: boolean;
  total: number;
  page: number;
  limit: number;
  onPageChange: (page: number) => void;
  onEdit: (video: Video) => void;
  onDelete: (id: number) => void;
  onTogglePublic: (id: number) => void;
}

export function VideosTable({ videos, loading, total, page, limit, onPageChange, onEdit, onDelete, onTogglePublic }: VideosTableProps) {
  return (
    <TableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Название</TableCell>
            <TableCell>Категория</TableCell>
            <TableCell>Статус</TableCell>
            <TableCell>Действия</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {videos.map((video) => (
            <TableRow key={video.id} hover>
              <TableCell>{video.title}</TableCell>
              <TableCell>{video.category || '-'}</TableCell>
              <TableCell>
                <Chip label={video.isPublic ? 'Публичное' : 'Приватное'} size="small" color={video.isPublic ? 'success' : 'default'} />
              </TableCell>
              <TableCell>
                <Box sx={{ display: 'flex', gap: 0.5 }}>
                  <Tooltip title="Просмотр"><IconButton size="small"><Visibility fontSize="small" /></IconButton></Tooltip>
                  <Tooltip title="Редактировать"><IconButton size="small" onClick={() => onEdit(video)}><Edit fontSize="small" /></IconButton></Tooltip>
                  <Tooltip title={video.isPublic ? 'Скрыть' : 'Опубликовать'}>
                    <IconButton size="small" onClick={() => onTogglePublic(video.id)}><CheckCircle fontSize="small" color={video.isPublic ? 'success' : 'disabled'} /></IconButton>
                  </Tooltip>
                  <Tooltip title="Удалить"><IconButton size="small" onClick={() => onDelete(video.id)} sx={{ color: 'error.main' }}><Delete fontSize="small" /></IconButton></Tooltip>
                </Box>
              </TableCell>
            </TableRow>
          ))}
          {videos.length === 0 && !loading && (
            <TableRow><TableCell colSpan={4} align="center"><Typography color="text.secondary">Видео не найдены</Typography></TableCell></TableRow>
          )}
        </TableBody>
      </Table>
      <TablePagination component="div" count={total} page={page - 1} onPageChange={(_, newPage) => onPageChange(newPage + 1)} rowsPerPage={limit} rowsPerPageOptions={[]} />
    </TableContainer>
  );
}

interface VideosToolbarProps { search: string; onSearchChange: (value: string) => void; }
export function VideosToolbar({ search, onSearchChange }: VideosToolbarProps) {
  return (
    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2, mb: 2 }}>
      <TextField label="Поиск" variant="outlined" size="small" value={search} onChange={(e) => onSearchChange(e.target.value)} sx={{ minWidth: 200 }} />
    </Box>
  );
}
